import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';
import { Helmet } from 'react-helmet';
import { useInView } from 'react-intersection-observer';
import './CountUp.css';
import { useTranslation } from 'react-i18next';

const CountUp = () => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const { t, i18n } = useTranslation();
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: true });

  useEffect(() => {
    if (inView) {
      controls.start({ opacity: 2, y: 0 });
    }
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={controls}
      transition={{ duration: 2 }}
      className="countup"
    >
      <div className="countup_header">
        <br />
        <h1>{t('Les Forces de Professional Inspectors')}</h1>
      </div>
      <div className="countup_body">
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 2, x: 0 }}
          transition={{ duration: 3 }}
          className="countup_card"
        >
          <img className="img" src="/images/integrité.png" alt="Intégrité" />
          <h2>{t('Intégrité')}</h2>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 2, x: 0 }}
          transition={{ duration: 3 }}
          className="countup_card"
        >
          <img className="img" src="/images/confiance.png" alt="Confiance" />
          <h2>{t('Confiance')}</h2>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 2, x: 0 }}
          transition={{ duration: 3 }}
          className="countup_card"
        >
          <img className="img" src="/images/précision.png" alt="Précision" />
          <h2>{t('Précision')}</h2>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 2, x: 0 }}
          transition={{ duration: 3 }}
          className="countup_card"
        >
          <img className="img" src="/images/poly.png" alt="Polyvalence" />
          <h2>{t('Polyvalence')}</h2>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 2, x: 0 }}
          transition={{ duration: 3 }}
          className="countup_card"
        >
          <img className="img" src="/images/reactivité.png" alt="Réactivité" />
          <h2>{t('Réactivité')}</h2>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default CountUp;
